import * as Types from '../generatedTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type PickingJobPickedItemsQueryVariables = Types.Exact<{
  picking_job_id: Types.Scalars['ID'];
  search?: Types.InputMaybe<Types.Scalars['String']>;
  skip?: Types.InputMaybe<Types.Scalars['Int']>;
  take?: Types.InputMaybe<Types.Scalars['Int']>;
}>;


export type PickingJobPickedItemsQuery = { __typename?: 'Query', getPickingJobPickedItemsPaginated: { __typename?: 'PickingJobPickedItemsPage', total: number, items: Array<{ __typename?: 'PickingJobPickedItem', id: string, reference_id?: string | null, kind: Types.OpsOrderItemCategory, name?: string | null, amount: number, added_at: string, delivered_amount: number, delivered_at?: string | null, added_by?: { __typename?: 'IdName', id: string, name: string } | null }> } };


export const PickingJobPickedItemsDocument = gql`
    query PickingJobPickedItems($picking_job_id: ID!, $search: String, $skip: Int, $take: Int) {
  getPickingJobPickedItemsPaginated(
    picking_job_id: $picking_job_id
    search: $search
    skip: $skip
    take: $take
  ) {
    total
    items {
      id
      reference_id
      kind
      name
      amount
      added_at
      added_by {
        id
        name
      }
      delivered_amount
      delivered_at
    }
  }
}
    `;

/**
 * __usePickingJobPickedItemsQuery__
 *
 * To run a query within a React component, call `usePickingJobPickedItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePickingJobPickedItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePickingJobPickedItemsQuery({
 *   variables: {
 *      picking_job_id: // value for 'picking_job_id'
 *      search: // value for 'search'
 *      skip: // value for 'skip'
 *      take: // value for 'take'
 *   },
 * });
 */
export function usePickingJobPickedItemsQuery(baseOptions: Apollo.QueryHookOptions<PickingJobPickedItemsQuery, PickingJobPickedItemsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PickingJobPickedItemsQuery, PickingJobPickedItemsQueryVariables>(PickingJobPickedItemsDocument, options);
      }
export function usePickingJobPickedItemsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PickingJobPickedItemsQuery, PickingJobPickedItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PickingJobPickedItemsQuery, PickingJobPickedItemsQueryVariables>(PickingJobPickedItemsDocument, options);
        }
export type PickingJobPickedItemsQueryHookResult = ReturnType<typeof usePickingJobPickedItemsQuery>;
export type PickingJobPickedItemsLazyQueryHookResult = ReturnType<typeof usePickingJobPickedItemsLazyQuery>;
export type PickingJobPickedItemsQueryResult = Apollo.QueryResult<PickingJobPickedItemsQuery, PickingJobPickedItemsQueryVariables>;